import { rgba } from 'polished';
import { ReactNode } from 'react';
import Carousel from 'react-multi-carousel';
import styled from 'styled-components';

import { Account } from 'shared/api/accounts';
import { ArrowBtnLeft, ArrowBtnRight } from 'shared/components/CarouselArrows';
import Heading from 'shared/components/Heading';
import Section from 'shared/components/Section';

import VipCard from './VipCard';
import { VIP_CONFIGS } from './vipConfigs';

const SectionVip = styled(Section)`
  font-family: ${({ theme }) => theme.FONTS.MAIN};
  padding-top: 2rem;
`;

const StyledArrowBtnRight = styled(ArrowBtnRight)`
  ${({ theme }) => theme.MEDIA.MD} {
    right: 24px;
  }
`;

const StyledArrowBtnLeft = styled(ArrowBtnLeft)`
  ${({ theme }) => theme.MEDIA.MD} {
    left: 24px;
  }
`;

const CarouselWrapper = styled.div`
  margin: 0 auto;
  max-width: 40rem;

  ${({ theme }) => theme.MEDIA.MD} {
    max-width: 180rem;
  }

  ${StyledArrowBtnLeft}, ${StyledArrowBtnRight} {
    background: ${rgba('#ffffff', 0.6)};
    transition: background 0.3s;

    &:hover {
      background: ${rgba('#ffffff', 0.8)};
    }

    &:focus {
      background: ${rgba('#ffffff', 0.9)};
      outline: 0;
    }
  }
`;

const responsive = {
  bp1: {
    breakpoint: { min: 1165, max: 5000 },
    items: 4,
  },
  bp2: {
    breakpoint: { min: 1165, max: 1519 },
    items: 3,
  },
  bp3: {
    breakpoint: { min: 768, max: 1164 },
    items: 2,
  },
  bp4: {
    breakpoint: { min: 0, max: 767 },
    items: 1,
  },
};

type VipProps = {
  accounts: Account[];
  children: ReactNode;
};

function Vip({ accounts, children }: VipProps): JSX.Element {
  return (
    <SectionVip>
      <Heading as="h2">{children}</Heading>
      <CarouselWrapper>
        <Carousel
          responsive={responsive}
          customRightArrow={<StyledArrowBtnRight />}
          customLeftArrow={<StyledArrowBtnLeft />}
          removeArrowOnDeviceType={['bp1']}
          ssr
          infinite
        >
          {accounts.map((account, index) =>
            index < VIP_CONFIGS.length ? (
              <VipCard
                key={account.id}
                {...VIP_CONFIGS[index]}
                averageGrade={account.averageGrade}
                reviewsCount={account.reviewsCount}
              />
            ) : null,
          )}
        </Carousel>
      </CarouselWrapper>
    </SectionVip>
  );
}

export default Vip;
